import { Map } from 'immutable';
import { practiceListActions } from '../practice-lists';
import { createPractice } from './practice';

export function practicesReducer(state = new Map(), {payload, type}) {
  switch (type) {
    case practiceListActions.FETCH_PRACTICES_SUCCESS:
      return state.withMutations( practices => {
        if(Array.isArray(payload.data)) {
            payload.data.forEach( practiceData => {
                practices.set(practiceData.id, createPractice(practiceData));
            })
        } 
        // if(Array.isArray(payload.data)) {
        //     payload.data.forEach( practiceData => {
        //         if (!practices.has(practiceData.id)) {
        //             practices.set(practiceData.id, createPractice(practiceData));
        //         }
        //     })
        // } 
        // else {
        //     practices.set(payload.practiceListId.id, createPractice(payload.data));
        // }
      });
    default:
      return state;
  }
}
